import { render } from "./Cart-order.vue?vue&type=template&id=08928003&scoped=true"
import script from "./Cart-order.vue?vue&type=script&lang=js"
export * from "./Cart-order.vue?vue&type=script&lang=js"

import "./Cart-order.vue?vue&type=style&index=0&id=08928003&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08928003"]])

export default __exports__